import { getMomentDate } from "utils/commonUtils";
import BaseModel from "./BaseModel";

export default class AppUI extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || '';
        this.screenType = data.screenType || undefined;
        this.backgroundName = data.backgroundName || '';
        this.title = data.title || '';
        this.description = data.description || data.descriptions || '';
        this.order = data.order || undefined;
        this.isDisplay = data.isDisplay || false;
        this.logoImage = data.logoImage || undefined;
        this.backgroundImage = data.backgroundImage || undefined;
        this.createdDate = getMomentDate(data.createdDate);
        this.translations = data.translations || [];
        this.logoImageName = data?.logoImageName || data?.logoImage?.fileName || data?.logoImage?.filename || undefined;
        this.backgroundImageName = data?.backgroundImageName || data?.backgroundImage?.fileName || data?.backgroundImage?.filename || undefined;
        this.languageCode = data?.languageCode || undefined;
        this.tourTypeId = data?.tourTypeId || undefined;
    }

    export() {
        return {
            screenType: this.screenType,
            languageCode: this.languageCode,
            backgroundName: this.backgroundName,
            title: this.title,
            descriptions: this.description,
            order: this.order,
            logoImageName: this.logoImageName,
            backgroundImageName: this.backgroundImageName,
            isDisplay: this.isDisplay,
            tourTypeId: this.tourTypeId
        }
    }

    exportUpdateConfig() {
        return {
            id: this.id,
            screenType: this.screenType,
            languageCode: this.languageCode,
            backgroundName: this.backgroundName,
            title: this.title,
            descriptions: this.description,
            order: this.order,
            logoImageName: this.logoImageName,
            backgroundImageName: this.backgroundImageName,
            isDisplay: this.isDisplay,
            tourTypeId: this.tourTypeId
        }
    }

    exportCreateTranslation() {
        return {
            appUIConfigurationId: this.id,
            languageCode: this.languageCode,
            title: this.title,
            descriptions: this.description,
            logoImageName: this.logoImageName,
            backgroundImageName: this.backgroundImageName,
            isDisplay: this.isDisplay,
            tourTypeId: this.tourTypeId
        }
    }

    exportUpdateTranslation() {
        const idTranslation = this.translations.find(el => el.languageCode === this.languageCode).id;
        return {
            id: idTranslation,
            appUIConfigurationId: this.id,
            languageCode: this.languageCode,
            title: this.title,
            descriptions: this.description,
            logoImageName: this.logoImageName,
            backgroundImageName: this.backgroundImageName,
            isDisplay: this.isDisplay,
            tourTypeId: this.tourTypeId
        }
    }

}